import { Component, Inject, forwardRef } from '@angular/core';

@Component({
  selector: 'app-footer',
  template: `
    <div class="layout-footer">
      <div class="logo-text">
        <img src="assets/images/insep_logo_blanc.png" alt="mirage-layout" />
        <div class="text">
          <h1>DSA</h1>
          <span></span>
        </div>
      </div>
      <div class="icons">
        <div class="icon icon-hastag">
          <a class="" [routerLink]="['/']"><i class="pi pi-home"></i></a>
        </div>
      </div>
    </div>
  `,
})
export class AppFooterComponent {}
